import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BroadcastService } from 'app/core/services/broadcast.service';
import { PrivateService } from 'app/core/services/private.service';

@Component({
  selector: 'dialog-add-broadcast',
  templateUrl: './dialog-add-broadcast.component.html',
  styleUrls: ['./dialog-add-broadcast.component.scss']
})
export class DialogAddBroadcastComponent implements OnInit {
  selectedTargetType: 'department' | 'branch' | 'user' | 'everyone' | null = null;
  messageContent: string = '';

  // Form Controls
  departmentCtrl = new FormControl();
  branchCtrl = new FormControl();
  employeeCtrl = new FormControl();

  // Dropdown data
  departments: any[] = [];
  branches: any[] = [];
  employees: any[] = [];

  // Filtered lists
  filteredBranches: any[] = [];
  filteredDepartments: any[] = [];
  filteredEmployee: any[] = [];

  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogAddBroadcastComponent>,
    public privateService: PrivateService,
    public broadcastService: BroadcastService
  ) { }

  ngOnInit(): void {
    // Uncomment these when service is available
    this.getDepartments();
    this.getBranches();
    this.getEmployees();

    // Setup autocomplete filtering
    this.departmentCtrl.valueChanges.subscribe(value => {
      this.filteredDepartments = this._filter(value, this.departments, 'departmentName');
    });

    this.branchCtrl.valueChanges.subscribe(value => {
      this.filteredBranches = this._filter(value, this.branches, 'Name');
    });

    this.employeeCtrl.valueChanges.subscribe(value => {
      this.filteredEmployee = this._filter(value, this.employees, 'employeeName');
    });
  }

  private _filter(value: any, list: any[], key: string) {
    // If value is an object (selected option), use its display name for filtering
    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    if (!filterValue) return list;

    return list.filter(item => (item[key] || '').toLowerCase().includes(filterValue));
  }

  // Uncomment when service is available
  getDepartments() {
    this.privateService.getDepartmentsAll().subscribe(response => {
      this.departments = response;
      this.filteredDepartments = this.departments;
    });
  }

  getBranches() {
    this.privateService.getBranchesAll().subscribe(response => {
      this.branches = response;
      this.filteredBranches = this.branches;
    });
  }

  getEmployees() {
    this.privateService.getEmployeeInfoAll().subscribe(response => {
      this.employees = response;
      this.filteredEmployee = this.employees;
    });
  }

  onTargetTypeChange(type: 'department' | 'branch' | 'user' | 'everyone'): void {
    // Reset other checkboxes and selections
    if (this.selectedTargetType === type) {
      this.selectedTargetType = null;
    } else {
      this.selectedTargetType = type;
    }

    // Reset form controls
    this.departmentCtrl.reset();
    this.branchCtrl.reset();
    this.employeeCtrl.reset();
  }

  isFormValid(): boolean {
    const hasTarget = (this.selectedTargetType === 'department' && this.departmentCtrl.value) ||
      (this.selectedTargetType === 'branch' && this.branchCtrl.value) ||
      (this.selectedTargetType === 'user' && this.employeeCtrl.value) || this.selectedTargetType === 'everyone';

    return !!(hasTarget && this.messageContent.trim());
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSend(): void {
    this.isLoading = true;

    if (!this.isFormValid()) {
      console.warn('Form is not valid');
      return;
    }

    let targetName = '';
    let targetType = '';
    let targetId = 0;

    if (this.selectedTargetType === 'department') {
      targetName = this.departmentCtrl.value;
      targetType = 'Department';
      const dept = this.departments.find(d => d.departmentName === targetName);
      targetId = dept ? dept.hr_Department_ID : 0;
    } else if (this.selectedTargetType === 'branch') {
      targetName = this.branchCtrl.value;
      targetType = 'Branch';
      const branch = this.branches.find(b => b.Name === targetName);
      targetId = branch ? branch.C_Activity_ID : 0;
    } else if (this.selectedTargetType === 'user') {
      targetName = this.employeeCtrl.value;
      targetType = 'User';
      const employee = this.employees.find(e => e.employeeName === targetName);
      targetId = employee ? employee.C_BPartner_ID : 0;
    } else if (this.selectedTargetType === 'everyone') {
      targetName = 'Everyone';
      targetType = 'Everyone';
    }

    const formBody = {
      targetType: targetType,
      targetName: targetName,
      targetId: targetId,
      message: this.messageContent,
      createdDate: new Date(),
      status: 'Sent'
    };

    this.broadcastService.insert_broadcast_message(formBody).subscribe({
      next: (response) => {
        this.dialogRef.close(formBody);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error sending broadcast message:', error);
        this.isLoading = false;
      }
    })
  }
}